// This is root view.
// This loads first.
// This probably does nothing.
import { Token } from '@/api/token.js';
import Auth from '@/api/auth';

import { createNamespacedHelpers } from 'vuex';
import ConciergeDefs from '@/store/concierge/concierge.d';
import ChatDefs from '@/store/chat/chat.d';

const {
  mapState: mapConciergeState,
  mapActions: mapConciergeActions
} = createNamespacedHelpers('Concierge');

const { mapActions: mapChatActions } = createNamespacedHelpers('Chat');

export default {
  computed: {
    ...mapConciergeState({
      currentConcierge: state => state.currentConcierge
    })
  },
  created: async function() {
    const conciergeSession = Token.getConciergeSession();

    if (!conciergeSession) return;
    try {
      await this.conciergeStore_setCurrentConcierge(
        conciergeSession.conciergeId
      );
    } catch (error) {
      // Handle error in case the local conciergeSession hold invalid token or expired token
      Auth.logoutConcierge();
    }
    await this.chatStore_connect({
      id: conciergeSession.conciergeId,
      token: conciergeSession.sbAccessToken
    });
    await this.chatStore_leavePreviousChannels();
  },
  methods: {
    ...mapConciergeActions({
      conciergeStore_setCurrentConcierge:
        ConciergeDefs.actions.setCurrentConcierge
    }),

    ...mapChatActions({
      chatStore_connect: ChatDefs.actions.connect,
      chatStore_leavePreviousChannels: ChatDefs.actions.leavePreviousChannels
    })
  }
};
